import React from "react";
import styles from "./FloatingMenu.module.css";
export const FloatingMenuItem = ({
  children,
  onClick,
}: {
  children: React.ReactNode;
  onClick?: () => void;
}) => {
  return (
    <div onClick={onClick} className={styles.MenuItem} role="button">
      {children}
    </div>
  );
};
